import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import ReturnPolicyList from './ReturnPolicy/ReturnPolicyList'
import ReturnPolicyDetailList from './ReturnPolicyDetails/ReturnPolicyDetailList'
import { useSelector } from 'react-redux'
import AssignReturnPolicyToCategoryList from './AssignReturnPolicyToCategory/AssignReturnPolicyToCategoryList'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

const ManageReturnTabbing = () => {
  const { pageAccess } = useSelector((state) => state.user)
  const [activeToggle, setActiveToggle] = useState(
    checkPageAccess(pageAccess, allPages?.manageReturn, allCrudNames?.read)
      ? 'return-policy'
      : checkPageAccess(
          pageAccess,
          allPages?.assignReturnToCategory,
          allCrudNames?.read
        )
      ? 'assign'
      : ''
  )
  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }
  return checkPageAccess(
    pageAccess,
    [allPages?.manageReturn, allPages?.assignReturnToCategory],
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            {checkPageAccess(
              pageAccess,
              allPages?.manageReturn,
              allCrudNames?.read
            ) && (
              <>
                <Link
                  onClick={(e) => handleTabClick(e, 'return-policy')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'return-policy' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Return Policy
                    <hr />
                  </span>
                </Link>
                <Link
                  onClick={(e) => handleTabClick(e, 'return-policy-detail')}
                  data-toggle='tab'
                  className={`nav-link fw-semibold ${
                    activeToggle === 'return-policy-detail' ? 'active show' : ''
                  }`}
                >
                  <span className='nav-span'>
                    Return Policy Detail
                    <hr />
                  </span>
                </Link>
              </>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.assignReturnToCategory,
              allCrudNames?.read
            ) && (
              <Link
                onClick={(e) => handleTabClick(e, 'assign')}
                data-toggle='tab'
                className={`nav-link fw-semibold ${
                  activeToggle === 'assign' ? 'active show' : ''
                }`}
              >
                <span className='nav-span'>
                  Assign Return to Category
                  <hr />
                </span>
              </Link>
            )}
          </div>

          <div className='tab-content p-3'>
            {checkPageAccess(
              pageAccess,
              allPages?.manageReturn,
              allCrudNames?.read
            ) && (
              <>
                <div
                  id='return-policy'
                  className={`tab-pane fade ${
                    activeToggle === 'return-policy' ? 'active show' : ''
                  }`}
                >
                  {activeToggle === 'return-policy' && <ReturnPolicyList />}
                </div>
                <div
                  id='return-policy-detail'
                  className={`tab-pane fade ${
                    activeToggle === 'return-policy-detail' ? 'active show' : ''
                  }`}
                >
                  {activeToggle === 'return-policy-detail' && (
                    <ReturnPolicyDetailList />
                  )}
                </div>
              </>
            )}
            {checkPageAccess(
              pageAccess,
              allPages?.assignReturnToCategory,
              allCrudNames?.read
            ) && (
              <div
                id='assign'
                className={`tab-pane fade ${
                  activeToggle === 'assign' ? 'active show' : ''
                }`}
              >
                {activeToggle === 'assign' && (
                  <AssignReturnPolicyToCategoryList />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default ManageReturnTabbing
